import React from "react";
import { useSelector } from "react-redux";
import { Chip, Dot } from "@activecollab/components";
import PropTypes from "prop-types";
import { TooltipCss } from "~/components/TooltipCss/TooltipCss";
import { getTaskLabelById } from "~/store/selectors/selector.labels";

export const LabelItem = ({ labelId, showAsDot = false }) => {
  const label = useSelector((state) => getTaskLabelById(state, labelId));
  if (!label) {
    return null;
  }

  if (showAsDot) {
    return (
      <Dot
        color={label.color}
        size={20}
        className="tw-mr-0.5 last:tw-mr-0 c-cooltip c-cooltip--top"
        data-tooltip={label.name}
      />
    );
  }
  return (
    <TooltipCss
      title={label.name}
      className="tw-flex tw-mr-0.5 last:tw-mr-0 tw-shrink-0"
    >
      <Chip
        backgroundColor={label.color}
        style={{ maxWidth: "90px" }}
        label={label.name}
        color="#303037"
        variant="Caption 2"
      />
    </TooltipCss>
  );
};

LabelItem.propTypes = {
  labelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showAsDot: PropTypes.bool,
};
